import * as React from "react";
import {observer} from "mobx-react";
import {SelectInput} from "../../../../../widgets/input/select/SelectInput";

interface ColorRuleRowProps {
	readonly label: string;
	readonly options: string[];
	readonly onChangeIndicator: (fieldName: string) => void;
	readonly selectedIndicator: string;
	readonly onChangeHighlight: (fieldName: string) => void;
	readonly selectedHighlight: string;
	readonly render?: (item: any) => React.ReactNode;
}

@observer
export class ColorRuleRow extends React.Component<ColorRuleRowProps> {
	public override render() {
		const {render, label, options, onChangeIndicator, onChangeHighlight, selectedIndicator, selectedHighlight} = this.props;

		const indicatorProps = {sort: false, options, render, onChange: onChangeIndicator, selected: selectedIndicator};
		const highlightProps = {sort: false, options, render, onChange: onChangeHighlight, selected: selectedHighlight};

		return (
			<div className="ColorRuleRow hbox">
				<div className="label">{label}</div>
				<SelectInput {...indicatorProps} />
				<SelectInput {...highlightProps} />
			</div>
		);
	}
}
